import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CustomPdfViewerModule } from '../../custom-pdf-viewer/custom-pdf-viewer.module';
import { ConfirmModalComponent } from './confirm-modal.component';

@NgModule({
    declarations: [ConfirmModalComponent],
    imports: [
        NgbModule,
        HttpClientModule,
        NgxSpinnerModule,
        CustomPdfViewerModule,
        CommonModule,
    ],
    exports: [ConfirmModalComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConfirmModalModule {}
